export default "__VITE_ASSET__CfPzftk___"